module.exports = __webpack_public_path__ + "cd0bd1d7c282b172628543045455ab2d.svg";